import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en, zh } from "./locale";
import bridgeuOverlay from "./locale/en/brands/bridgeu.json";

const resources = {
  "en-US": {
    translation: en,
  },
  "zh-CN": {
    translation: zh,
  },
  // Sparse per-brand overlays: only the keys that differ for a brand live here.
  // Anything missing falls back to the base "en-US" resource (see fallbackLng).
  // The active brand overlay is selected by getBrandLanguage() in src/brands.
  "en-US-bridgeu": {
    translation: bridgeuOverlay,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en-US",
  // Object map so a brand overlay falls back to its base language, and every
  // language ultimately falls back to en-US.
  fallbackLng: {
    "en-US-bridgeu": ["en-US"],
    default: ["en-US"],
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
